var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"flex":"1"},attrs:{"id":"app"}},[(_vm.$route.name !== 'privacy-policy' && _vm.$route.name !== 'home')?_c('TheHeader'):_vm._e(),_c('RouterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }